import { getUtilityBehaviorFromRequirements } from "@Light/utils/utility";
import { useEnrollment } from "./flow/context";

export function useEnrollmentUtilityConfiguration() {
  const { requirements } = useEnrollment();
  return getUtilityBehaviorFromRequirements(requirements);
}
